import { render } from "./FrozenMember.vue?vue&type=template&id=8b0c4b88&scoped=true"
import script from "./FrozenMember.vue?vue&type=script&lang=js"
export * from "./FrozenMember.vue?vue&type=script&lang=js"

import "./FrozenMember.vue?vue&type=style&index=0&id=8b0c4b88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0c4b88"]])

export default __exports__